export const Functions = {
  create: false,
  delete: false,
  detail: true,
  search: true,
};

export const PageName = '绿途中国梦登记列表';
